import { render, staticRenderFns } from "./ReviewYourAnswersNLP.vue?vue&type=template&id=7b6ae6c0"
import script from "./ReviewYourAnswersNLP.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersNLP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports